// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ConsentBlock-module-radioGroupGrid-3UQXn{display:grid;grid-template-columns:-webkit-min-content auto;grid-template-columns:min-content auto}.ConsentBlock-module-radioInput-7Sf_l{grid-column:1/2;-webkit-margin-start:-11px;margin-inline-start:-11px}.ConsentBlock-module-radioInputLabel-aycdS{grid-column:2;align-self:center}.ConsentBlock-module-benefitsListWrapper-3WDxM{grid-column:2;-webkit-margin-start:12px;margin-inline-start:12px}.ConsentBlock-module-benefitsListWrapper-3WDxM li{list-style:disc}.ConsentBlock-module-listCta-2tD9s{grid-column:2;width:-webkit-max-content;width:max-content}.ConsentBlock-module-error-3SoqE.ConsentBlock-module-error-3SoqE{border-color:red}", ""]);
// Exports
exports.locals = {
	"radioGroupGrid": "ConsentBlock-module-radioGroupGrid-3UQXn",
	"radioInput": "ConsentBlock-module-radioInput-7Sf_l",
	"radioInputLabel": "ConsentBlock-module-radioInputLabel-aycdS",
	"benefitsListWrapper": "ConsentBlock-module-benefitsListWrapper-3WDxM",
	"listCta": "ConsentBlock-module-listCta-2tD9s",
	"error": "ConsentBlock-module-error-3SoqE"
};
module.exports = exports;
